import request from '@/utils/request';

const baseURL = '/financeapi/finance/home';

export const getSystemTime = (data) =>
  request({
    data,
    url: `${baseURL}/getSystemTime`,
    method: 'post'
  });

export const getAuthorizedStores = (data) =>
  request({
    data,
    url: `${baseURL}/getAuthorizedStores`,
    method: 'post'
  });

export const findAvailableStores = data =>
  request({
    data,
    url: `${baseURL}/findAvailableStores`,
    method: 'post'
  });
